
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { QuestionV2 } from "@/lib/model/exambuilder/question-v2";
@Component({})
export default class MessageDialog extends Vue {
  @Prop({}) question!: QuestionV2;
  strictOrderEnum = {
    1: "完全一致",
    2: "顺序可不一致"
  };
  ignoreBlankEnum = {
    1: "忽略答案中的空格",
    2: "不忽略答案中的空格"
  };
  scoreTypeEnum = {
    1: "出错得0分，全对得满分",
    2: "按答对比例给分",
    3: "各分数独立设置"
  };

  mounted() {
    // console.log(a);
  }
}
